
import Vue from 'vue'
import { headerApi, HeaderDto } from '@/api/header'
import { formatAddress } from '@/utils/addresses'
import TitlePage from '@/components/TitlePage.vue'
import { handleAxiosException } from '@/api'
import HeaderDialog from './HeaderDialog.vue'

export default Vue.extend({
  components: { HeaderDialog, TitlePage },
  data() {
    return {
      error: '',
      loading: false,
      editDialog: {
        active: false,
        header: undefined as HeaderDto|undefined,
      },
      headers: [] as HeaderDto[],
      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
      lengthPagination: 1,
    }
  },
  methods: {
    formatAddress,
    setPage(page: number) {
      if (page !== this.page) {
        this.$router.push({ query: { page: page.toString() } })
      }
    },
    create() {
      this.editDialog = {
        active: true,
        header: undefined,
      }
    },
    edit(p: HeaderDto) {
      this.editDialog = {
        header: p,
        active: true,
      }
    },
    onSuccessSave(p: HeaderDto) {
      this.snackbarSuccessRegistration = {
        active: true,
        message: this.$t('success.save', { name: p.line1 }) as string,
      }
      this.editDialog.active = false
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const page = (await headerApi.getAllHeaders({ page: this.page - 1, size: 20 }))
        this.lengthPagination = page.totalPages
        this.headers = page.content
      } catch (err) {
        this.error = this.$t(handleAxiosException(err, () => 'error.loading')) as string
      }
      this.loading = false
    },
  },
  computed: {
    page(): number {
      return parseInt(this.$route.query.page as string ?? '1', 20)
    },
  },
  watch: {
    page() {
      this.loadData()
    },
  },
  async mounted() {
    this.loadData()
  },
})
